import { Component, OnInit, Input } from '@angular/core';
import type { CurrentUser } from '@nuso/auth/types';

@Component({
    selector: 'nuso-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    standalone: false
})
export class UserMenuComponent {
  @Input() user: CurrentUser;
  mobile = screen.width <= 480;

  constructor() { }

}
